// Essa const deve ser incrementada com os ids dos blocos que o usuário pode editar,
// será populada de acordo com a implementação dos novos blocos
export const blocosCategoriaDisponiveis = [1, 5, 9, 3, 4];
